import { Payment} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const payment = {
    id: 'payment',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'payment',
            title: 'Payment',
            type: 'item',
            url: '/payment',
            icon: Payment,
            breadcrumbs: false,
            
        },
       
    ]
};

export default payment;
